export const AboutImage = ({
    src,
    alt,
}: {
    src: string;
    alt: string;
}) => {
    return (
        <div className="w-full max-w-2xl h-[300px] md:h-[500px] mx-auto overflow-hidden rounded-2xl   ">
            <img
                src={src}
                alt={alt}
                className="w-full h-full object-cover object-center"
                loading="lazy"
            />
        </div>
    );
};
